module.exports = __webpack_public_path__ + "static/media/payment-option-bkash.67e82e9c.svg";